import React from 'react';
import PropTypes from 'prop-types';
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer
} from 'recharts';

const SimpleBarChart = ({ data }) => (
  <ResponsiveContainer height={300} width="100%">
    <BarChart data={data} margin={{ top: 20, left: -10 }}>
      <CartesianGrid strokeDasharray="3 3" />
      <XAxis dataKey="reference_name" />
      <Tooltip />
      <Legend />

      <YAxis yAxisId="left" orientation="left" stroke="#00C49F" style={{ direction: "ltr", marginLeft: '5px' }} />
      <Bar yAxisId="left" dataKey="compliant" fill="#00C49F" />

      <YAxis yAxisId="middle" orientation="right" stroke="#f3c363" style={{ direction: "ltr", marginLeft: '5px' }} />
      <Bar yAxisId="middle" dataKey="partial" fill="#f3c363" />

      <YAxis yAxisId="right" orientation="right" stroke="#eb3349" style={{ direction: "ltr", marginLeft: '5px' }} />
      <Bar yAxisId="right" dataKey="nonCompliant" fill="#eb3349" />
    </BarChart>
  </ResponsiveContainer>
);

SimpleBarChart.propTypes = {
  data: PropTypes.arrayOf(PropTypes.shape({
    reference_name: PropTypes.string,
    compliant: PropTypes.number,
    partial: PropTypes.number,
    nonCompliant: PropTypes.number,
  })).isRequired,
};

export default SimpleBarChart;
